import { tv } from 'tailwind-variants';

export const searchResultsVariants = tv({
  slots: {
    noResults: 'py-4 text-textPrimary',
    list: 'flex flex-col',
  },
});
